/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Event listeners available for custom functionality
  // Uncomment below for debugging in development only

  // document.addEventListener('theme:variant:change', function (event) {
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container:', container);
  //     console.log('Variant:', variant);
  //   }
  // });

  // document.addEventListener('theme:cart:change', function (event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart:', cart);
  //   }
  // });

  // Removed console.logs for production performance
  // document.addEventListener('theme:cart:init', (e) => { console.log('theme:cart:init', e); });
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Video autoplay: play only when visible in viewport (reduces main thread work
  // for below-fold videos), pause when scrolled out to save CPU/GPU.
  document.addEventListener("DOMContentLoaded", function () {
    var videos = document.querySelectorAll("video.media-video");
    if (!videos.length) return;

    if (window.innerWidth <= 768) {
      // Mobile: disable autoplay to prevent layout blocking
      videos.forEach(function (video) {
        video.pause();
        video.removeAttribute("autoplay");
      });
      return;
    }

    // Desktop: IntersectionObserver plays only visible videos
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.setAttribute("muted", "");
          video.setAttribute("playsinline", "");
          video.setAttribute("loop", "");
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: "100px", threshold: 0.1 });

    videos.forEach(function (video) { observer.observe(video); });
  });

  // Mobile product grid swipe: on phones the theme shows one static photo per
  // product. This turns the photo area into a native scroll-snap carousel with
  // an infinite loop. Performance rules:
  // - a carousel is only built when its product is about to scroll into view;
  // - loop copies stay inert (<template>, no <img>) until they're about to show;
  // - extra photos download only for products the shopper actually sees: the
  //   2nd photo is warmed once the page has loaded and the browser is idle,
  //   the rest as they swipe.
  (function () {
    function isPhone() {
      var bp = (window.theme && window.theme.sizes && window.theme.sizes.medium) || 768;
      return window.innerWidth < bp;
    }

    function load(img) {
      if (img && img.getAttribute('loading') !== 'eager') img.setAttribute('loading', 'eager');
    }

    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };

    var CLONE_STRIP = ['data-grid-image', 'data-grid-image-target', 'data-grid-current-image',
      'data-slide-for-filter-selected-variant', 'data-slide-for-variant-media'];

    // Copies are stripped of the theme's data attributes (so its image logic
    // never counts them) and kept inert until needed.
    function makeClone(img) {
      var clone = img.cloneNode(true);
      CLONE_STRIP.forEach(function (a) { clone.removeAttribute(a); });
      clone.setAttribute('loading', 'lazy');
      clone.setAttribute('data-swipe-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('.loading-shimmer').forEach(function (w) { w.classList.remove('loading-shimmer'); });
      var first = clone.firstElementChild;
      if (first && first.nodeName !== 'TEMPLATE') {
        var tpl = document.createElement('template');
        while (clone.firstChild) tpl.content.appendChild(clone.firstChild);
        clone.appendChild(tpl);
      }
      return clone;
    }

    var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
      entries.forEach(function (e) { if (e.target.__swipePlace) e.target.__swipePlace(); });
    }) : null;

    var pageLoaded = document.readyState === 'complete';
    var warmQueue = [];
    var warmObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        warmObserver.unobserve(e.target);
        idle(function () { if (e.target.__swipeWarm) e.target.__swipeWarm(); });
      });
    }, { threshold: 0.6 });
    function queueWarm(holder) {
      if (pageLoaded) warmObserver.observe(holder); else warmQueue.push(holder);
    }
    window.addEventListener('load', function () {
      pageLoaded = true;
      warmQueue.forEach(function (h) { warmObserver.observe(h); });
      warmQueue = [];
    });

    function build(el) {
      var holder = el.querySelector('[data-grid-images]');
      var link = el.querySelector('[data-grid-link]');
      var real = holder ? Array.prototype.slice.call(holder.querySelectorAll(':scope > product-grid-item-image')) : [];
      var n = real.length;
      if (!holder || !link || n < 2) return;

      // Slides: [copies of all photos] [real photos] [copies of all photos].
      // There's always room to keep swiping either way; once the shopper lets
      // go, the carousel quietly re-centres on the identical real photo.
      var before = real.map(makeClone);
      var after = real.map(makeClone);
      var head = document.createDocumentFragment();
      before.forEach(function (c) { head.appendChild(c); });
      holder.insertBefore(head, real[0]);
      var tail = document.createDocumentFragment();
      after.forEach(function (c) { tail.appendChild(c); });
      holder.appendChild(tail);
      var slides = before.concat(real, after);

      var bar = document.createElement('div');
      bar.className = 'pgi-swipe-bar';
      bar.setAttribute('aria-hidden', 'true');
      var seg = document.createElement('span');
      seg.style.width = (100 / n) + '%';
      bar.appendChild(seg);
      link.appendChild(bar);
      el.classList.add('is-swipe');

      var current = 0;
      for (var j = 0; j < n; j++) {
        if (real[j].hasAttribute('data-grid-current-image')) { current = j; break; }
      }

      function mod(v) { return ((v % n) + n) % n; }

      // Only the wrap last -> first (or the reverse) is animated.
      var segPos = null;
      var loopTimer = null;
      function setSeg(p) {
        if (segPos === p) return;
        if (segPos !== null && Math.abs(p - segPos) > 1) {
          bar.classList.add('is-looping');
          clearTimeout(loopTimer);
          loopTimer = setTimeout(function () { bar.classList.remove('is-looping'); }, 320);
        }
        segPos = p;
        seg.style.transform = 'translateX(' + (p * 100) + '%)';
      }

      // Loading indicator: only photos that were requested and aren't ready
      // yet shimmer, so at most a couple animate at any moment.
      function isReady(slide) {
        var img = slide.querySelector('img');
        return !!(img && img.complete && img.naturalWidth);
      }
      function request(slide) {
        load(slide);
        if (!isReady(slide)) slide.classList.add('is-pending');
      }
      function ready(e) {
        var slide = e.target.closest && e.target.closest('product-grid-item-image');
        if (slide) slide.classList.remove('is-pending');
      }
      holder.addEventListener('load', ready, true);
      holder.addEventListener('error', ready, true);

      function loadSlide(s) {
        if (s < 0 || s >= slides.length) return;
        request(slides[s]);
        request(real[mod(s)]);
      }

      // WebKit ignores programmatic scrollLeft on a snapping container, so
      // snapping is switched off for the instant of the jump.
      function jumpTo(s) {
        holder.style.scrollSnapType = 'none';
        holder.scrollLeft = s * holder.clientWidth;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { holder.style.scrollSnapType = ''; });
        });
      }

      holder.__swipePlace = function () { if (holder.clientWidth) jumpTo(n + current); };
      holder.__swipePlace();
      setSeg(current);
      if (!isReady(real[current])) real[current].classList.add('is-pending');
      if (resizeObserver) resizeObserver.observe(holder);

      // Warm the photo right after the current one so the first swipe is instant
      holder.__swipeWarm = function () { loadSlide(n + current + 1); };
      queueWarm(holder);

      var touched = false;
      var fingerDown = false;
      var settleTimer = null;

      function settle() {
        if (fingerDown) return;
        var w = holder.clientWidth;
        if (!w) return;
        var exact = holder.scrollLeft / w;
        var s = Math.round(exact);
        if (Math.abs(exact - s) > 0.02) return;
        current = mod(s);
        if (touched) loadSlide(s);
        if (s < n || s >= 2 * n) jumpTo(n + current);
        if (touched) {
          loadSlide(n + current);
          loadSlide(n + current + 1);
          loadSlide(n + current - 1);
        }
      }

      function scheduleSettle(delay) {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, delay);
      }

      var ticking = false;
      function update() {
        ticking = false;
        var w = holder.clientWidth;
        if (!w) return;
        var pos = holder.scrollLeft / w;
        if (touched) {
          loadSlide(Math.floor(pos + 0.02));
          loadSlide(Math.ceil(pos - 0.02));
        }
        setSeg(Math.min(n - 1, mod(pos - n)));
        scheduleSettle(150);
      }

      holder.addEventListener('touchstart', function () {
        touched = true;
        fingerDown = true;
        clearTimeout(settleTimer);
        var s = Math.round(holder.scrollLeft / (holder.clientWidth || 1));
        loadSlide(s + 1);
        loadSlide(s - 1);
        loadSlide(s + 2);
      }, { passive: true });
      function release() {
        fingerDown = false;
        scheduleSettle(150);
      }
      holder.addEventListener('touchend', release, { passive: true });
      holder.addEventListener('touchcancel', release, { passive: true });
      holder.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      holder.addEventListener('scrollend', function () { scheduleSettle(0); });
    }

    // Carousels are built just before their product scrolls into view.
    var buildObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        buildObserver.unobserve(e.target);
        build(e.target);
      });
    }, { rootMargin: '400px 0px' });

    function init() {
      if (!isPhone()) return;
      document.querySelectorAll('product-grid-item-variant:not([data-swipe-init])').forEach(function (el) {
        el.setAttribute('data-swipe-init', '');
        // Inside a product slider a horizontal swipe must move between
        // products, so photo swiping is never added there.
        if (el.closest('[data-carousel]')) return;
        buildObserver.observe(el);
      });
    }

    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; init(); }, 200);
    }

    // Only react when new product cards appear (filters, pagination), not to
    // every DOM change on the page.
    function hasNewCards(records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var k = 0; k < added.length; k++) {
          var node = added[k];
          if (node.nodeType !== 1) continue;
          if (node.matches('product-grid-item-variant') || node.querySelector('product-grid-item-variant:not([data-swipe-init])')) return true;
        }
      }
      return false;
    }

    document.addEventListener('DOMContentLoaded', function () {
      init();
      new MutationObserver(function (records) {
        if (hasNewCards(records)) schedule();
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    });
    document.addEventListener('theme:resize:width', schedule);
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
